/* index.ts
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import MobilePrinterModal from './MobilePrinterModal';

export default MobilePrinterModal;
